import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../../../../src/constants';

export default StyleSheet.create({
  container: {
    marginHorizontal: 10,
    paddingTop: 14,
    paddingBottom: 9,
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },
});
